export const FAB_SHOW = "fab/FAB_SHOW";

export function showFab(show) {
  return {
    type: FAB_SHOW,
    show,
  };
}
